import moment from "moment";

const formatYmd = (date:any) => date.toISOString().slice(0, 10);

export let today = formatYmd(new Date());

export let year = new Date().getFullYear();

export let todayDateWithTime = moment(new Date()).format("DD/MM/YYYY hh:mm:ss");